<template>
    <div>
        <b-row>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label>Contrato</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o número do contrato"
                            v-model="numeroContrato"
                            v-mask="'AA###/##'"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label>Gestor/Solicitante</label>
                    <model-select
                        :options="responsaveisOpcoes"
                        v-model="responsavel"
                        :isDisabled="!responsaveis"
                        :placeholder="responsaveis ? 'Pesquisar por nome...' : 'Carregando...'"
                    ></model-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label>Unidade do Contrato</label>
                    <model-select
                        :options="unidadesOpcoes"
                        v-model="unidade"
                        :isDisabled="!unidades"
                        :placeholder="unidades ? 'Pesquisar por nome...' : 'Carregando...'"
                    ></model-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label>Fornecedor</label>
                    <model-select
                        :options="fornecedoresOpcoes"
                        v-model="fornecedor"
                        :isDisabled="!fornecedores"
                        :placeholder="fornecedores ? 'Pesquisar por nome...' : 'Carregando...'"
                    ></model-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label :class="{ required: exigeVigencia }"
                        >Data Início da Vigência</label
                    >
                    <date-picker
                        v-model="dataInicioVigencia"
                        :config="$datePickerOptions2"
                        :required="exigeVigencia"
                        v-mask="'##/##/####'"
                    ></date-picker>
                    <small
                        v-if="exigeVigencia && !dataInicioVigencia"
                        class="form-text text-danger"
                    >
                        Obrigatório quando o status selecionado for Inativo ou
                        Ambos.
                    </small>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label :class="{ required: exigeVigencia }"
                        >Data Fim da Vigência</label
                    >
                    <date-picker
                        v-model="dataFimVigencia"
                        :config="$datePickerOptions2"
                        :required="exigeVigencia"
                        v-mask="'##/##/####'"
                    ></date-picker>
                    <small
                        v-if="exigeVigencia && !dataFimVigencia"
                        class="form-text text-danger"
                    >
                        Obrigatório quando o status selecionado for Inativo ou
                        Ambos.
                    </small>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label>Status</label>
                    <div class="d-flex align-items-start">
                        <b-form-select
                            class="flex-grow-1"
                            :options="statusOpcoesRetornadas"
                            v-model="status"
                            :disabled="!statusOpcoes"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>{{
                                    statusOpcoes ? 'Selecione...' : 'Carregando...'
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button
                            variant="primary"
                            class="ml-3"
                            style="min-width: 160px;"
                            @click="limparFiltros()"
                            >Limpar Filtros</b-button
                        >
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        ModelSelect
    },

    props: {
        responsaveis: {
            type: Array
        },
        unidades: {
            type: Array
        },
        fornecedores: {
            type: Array
        },
        statusOpcoes: {
            type: Array
        }
    },

    data() {
        return {
            numeroContrato: null,
            responsavel: null,
            unidade: null,
            fornecedor: null,
            dataInicioVigencia: null,
            dataFimVigencia: null,
            status: null
        }
    },

    methods: {
        limparFiltros() {
            this.numeroContrato = null
            this.responsavel = null
            this.unidade = null
            this.fornecedor = null
            this.dataInicioVigencia = null
            this.dataFimVigencia = null
            this.status = this.obterStatusPadrao()
        },

        obterStatusPadrao() {
            const statusPadrao = (this.statusOpcoes || []).find(
                (s) => s.statusId === 1
            )
            return statusPadrao ? statusPadrao.statusId : null
        }
    },

    computed: {
        responsaveisOpcoes() {
            return (this.responsaveis || []).map((r) => ({
                value: r.codFuncionario,
                text: r.nome
            }))
        },

        unidadesOpcoes() {
            return (this.unidades || []).map((u) => ({
                value: u.codUnidade,
                text: u.nome
            }))
        },

        fornecedoresOpcoes() {
            return (this.fornecedores || []).map((f) => ({
                value: f.codFornecedor,
                text: f.nome
            }))
        },

        statusOpcoesRetornadas() {
            return (this.statusOpcoes || []).map((s) => ({
                value: s.statusId,
                text: s.descricao
            }))
        },

        statusSelecionadoDescricao() {
            const statusSelecionado = (this.statusOpcoes || []).find(
                (s) => s.statusId === this.status
            )
            return statusSelecionado
                ? (statusSelecionado.descricao || '').toUpperCase()
                : ''
        },

        isInativo() {
            return this.statusSelecionadoDescricao.includes('INATIVO')
        },

        isAtivo() {
            return (
                this.statusSelecionadoDescricao.includes('ATIVO') &&
                !this.isInativo
            )
        },

        exigeVigencia() {
            return (
                this.isInativo || this.statusSelecionadoDescricao.includes('AMBOS')
            )
        },

        mensagemValidacaoVigencia() {
            if (this.exigeVigencia && !(this.dataInicioVigencia && this.dataFimVigencia)) {
                return 'Informe a Data Início e Data Fim da Vigência para emitir o relatório com o status selecionado.'
            }

            const hoje = this.$moment().startOf('day')

            if (this.isInativo && this.dataInicioVigencia && this.dataFimVigencia) {
                const inicio = this.$moment(
                    this.dataInicioVigencia,
                    'DD/MM/YYYY'
                ).startOf('day')
                const fim = this.$moment(
                    this.dataFimVigencia,
                    'DD/MM/YYYY'
                ).startOf('day')
                if (!inicio.isBefore(hoje) || !fim.isBefore(hoje)) {
                    return 'Para o status Inativo, as datas de vigência devem ser anteriores à data atual.'
                }
            }

            if (this.isAtivo && this.dataFimVigencia) {
                const fim = this.$moment(
                    this.dataFimVigencia,
                    'DD/MM/YYYY'
                ).startOf('day')
                if (!fim.isSameOrAfter(hoje)) {
                    return 'Para o status Ativo, a Data Fim da Vigência deve ser maior ou igual à data atual.'
                }
            }

            return null
        },

        filtro() {
            return {
                numeroContrato: this.numeroContrato,
                responsavel: this.responsavel,
                unidade: this.unidade,
                fornecedor: this.fornecedor,
                dataInicioVigencia: this.dataInicioVigencia
                    ? this.$moment(this.dataInicioVigencia, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataFimVigencia: this.dataFimVigencia
                    ? this.$moment(this.dataFimVigencia, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                status: this.status
            }
        }
    },

    watch: {
        filtro(novoFiltro) {
            this.$emit('filtroAtualizado', novoFiltro)
            this.$emit('mensagemValidacaoAtualizada', this.mensagemValidacaoVigencia)
        },

        statusOpcoes(value) {
            if (value && value.length) {
                this.status = this.obterStatusPadrao()
            }
        }
    }
}
</script>

